import { Pedido } from 'src/app/models/pedido';
import { PedidoCadastro, PedidoCadastroItem } from 'src/app/models/pedido-cadastro';
import { Group, Purchase, PurchaseItens, Order, OrderItens, OrderSummary } from 'src/app/models/purchase';
import { PurchaseRegister, PurchaseItensRegister, OrderRegister, OrderItensRegister } from 'src/app/models/purchase-register';


export class PurchaseConverter {

    // usado para continuar uma compra
    public static purchaseToPurchase(purchase: Purchase): PurchaseRegister {
        const purchaseItensRegister: PurchaseItensRegister[] = [];
        purchase.purchaseItens.forEach(obj => {
            const orderRegister = new OrderRegister(obj.order.orderId, obj.order.assignorContractId,
                obj.purchaseItemId, obj.order.orderValue, obj.order.releaseDate,obj.order.dueDate, obj.order.managerId, obj.order.totalFee, obj.order.totalFeePercent, obj.order.isPercent);
            orderRegister.orderItens = [];
            obj.order.orderItens.forEach(objr => {
                const orderItemRegister = new OrderItensRegister(objr.orderItemId, objr.providedValue, objr.cardId, objr.comments);
                if (objr.orderItemId > 0) {
                    orderItemRegister.hasApp = true;
                } else {
                    orderItemRegister.hasApp = false;
                }

                orderItemRegister.registry = objr.registry;
                orderItemRegister.name = objr.name;
                orderItemRegister.document = objr.document;

                orderItemRegister.referenceValue = objr.referenceValue;
                orderItemRegister.regularityId = objr.regularityId;
                orderRegister.orderItens.push(orderItemRegister);
            });
            orderRegister.productGuid = obj.order.productGuid;
            orderRegister.productDescription = obj.order.productDescription;
            orderRegister.orderDescription = obj.order.orderDescription;
            orderRegister.orderState = obj.order.orderState;

            const purchaseItemRegister: PurchaseItensRegister = new PurchaseItensRegister(obj.purchaseItemId, obj.purchaseId, obj.productId, orderRegister);
            purchaseItemRegister.purchaseId = obj.purchaseId;
            purchaseItemRegister.purchaseItemId = obj.purchaseItemId;
            purchaseItemRegister.productId = obj.productId;

            purchaseItensRegister.push(purchaseItemRegister);

        });
        const group = new Group();
        const purchaseRegister: PurchaseRegister = new PurchaseRegister(purchase.purchaseId, purchaseItensRegister, group,
            purchase.purchaseValue, purchase.purchaseValuePay,purchase.purchaseDescription, purchase.purchaseState,
            purchase.purchaseStateDescription, purchase.purchaseDate, purchase.paymentMethodId, purchase.purchaseUseBalance,purchase.purchaseFee)

        if(purchase.group != null){
            purchaseRegister.group.groupId = purchase.group.groupId;
            purchaseRegister.group.groupGuid = purchase.group.groupGuid;
        }

        return purchaseRegister;
    }

    public static purchaseToNewPurchase(purchase: Purchase): PurchaseRegister {
        const newPurchaseRegister: PurchaseRegister = PurchaseConverter.purchaseToPurchase(purchase);
        newPurchaseRegister.purchaseId = 0;
        newPurchaseRegister.purchaseItens.forEach(obj => {
            obj.purchaseItemId = 0;
        });
        return newPurchaseRegister;
    }
}
